import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the GeriBildirimEkleGuncellePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-geri-bildirim-ekle-guncelle',
  templateUrl: 'geri-bildirim-ekle-guncelle.html',
})
export class GeriBildirimEkleGuncellePage {
  vWBildirim: any = {};
  Bildirims: any = { ID: -1, Bildirim: "", FirmaAdi: "", BildirimDurumu: "", VerilenCevap: "" };
  firmaAdi = "";
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public viewCtrl: ViewController,

    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.FirmaGetir();
  }
  FirmaGetir() {
    this.bllOrtak.islemWithoutPost("FirmaBilgileri", "", false).then(a => {
      var sonuc = <any>a;
      this.firmaAdi = sonuc.SonucObject;
 
      if (this.firmaAdi.length > 0) {
        this.Bildirims.FirmaAdi = this.firmaAdi;
      }
      else {
        this.ortak.showBasicAlert("Hata", "Firma bilgilerinizi kontrol ediniz..")
      }
    }).catch(x => {
    })
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.Bildirims.Bildirim == null || this.Bildirims.Bildirim == "") {
      mesaj = mesaj + "Lütfen bildiriminizi boş bırakmayın. <br/>";
    }
    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }

  kaydet() {
    var formData = new FormData();
    if (this.boslukKontrol()) {
      this.Bildirims.BildirimDurumu = 1;
      formData.append("GeriBildirim", JSON.stringify(this.Bildirims));
      this.bllOrtak.geribildirim(formData, "GeriBildirimEkle", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "Değerli Müşterimiz Geri Bildiriminiz İçin Şükranlarımızı Sunarız İyi Çalışmalar :D");
        this.Bildirims.Bildirim = "";
        this.kapat();
        if (sonuc.Sonuc != 1) {
          this.ortak.showBasicAlert("Hata", "Değerli Müşterimiz Geri Bildiriminiz Gönderilemedi Lütfen Daha Sonra Tekrar Deneyiniz veya Bizimle İletişime Geçiniz.");
        }
      })
    }
  }

  kapat() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/geri-bildirim-ekle-guncelle/geri-bildirim-ekle-guncelle.ts